import Glide from '@glidejs/glide';

export default () => {

    if($('.content_pop')) {
        $('.pop__module .button--closer').on('click', () => {
            $('.content_pop').hide();

            const id = $('#pop-closer').data('id');
            createCookie('popup-' + id, 'closed', 7);
        });

        const createCookie = (name,value,days) => {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else {
                var expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }
    }

    if($('.page-template-page-other-disclaimer')) {
        $('.page-template-page-other-disclaimer .disclaimer-buttons .accept').on('click', function() {
            event.preventDefault();
            const href = $(this).attr('href');
            setCookie('yes');
            window.location = href;
        })
        $('.page-template-page-other-disclaimer .disclaimer-buttons .decline').on('click', function() {
            event.preventDefault();
            const href = $(this).attr('href');
            setCookie('no');
            window.location = href;
        })

        const setCookie = (accept) => {
            if(typeof accept === "undefined") {
                var accept = "";
            }
            if(accept == "yes") {
                eraseCookie("acceptedDisclaimer");
                createCookie("acceptedDisclaimer", "yes", 1);
            }
            if(accept == "no") {
                eraseCookie("acceptedDisclaimer");
                createCookie("acceptedDisclaimer", "no", 1);
            }
            return true;
        }

        const createCookie = (name,value,days) => {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else {
                var expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }

        const eraseCookie = (name) => {
            createCookie(name,"",-1);
        }
    }

    if($('.content_videotext').length > 0) {
        $('.content_videotext').find('.imgRemover').hover(function(){
            $(this).addClass('active');
        }, function(){
            $(this).removeClass('active');
        });
        $('.content_videotext').find('.imgRemover').click(function(){
            var src = $(this).siblings('iframe').attr('src');
            $(this).siblings('iframe').attr('src', src + '?autoplay=1');
            $(this).siblings('svg').remove();
            $(this).remove();
        });
        $('.content_videotext').find('.thumbnailRemover').each(function(){
            $(this).hover(function(){
                $(this).parent().parent().siblings('.imgContainer').children('img').addClass('active');
            }, function(){
                $(this).parent().parent().siblings('.imgContainer').children('img').removeClass('active');
            });
            $(this).click(function(){
                event.preventDefault();
                var imgContainer = $(this).parent().parent().parent().siblings('.imgContainer');
                imgContainer.children('img').remove();
                imgContainer.children('svg').remove();
                var src = imgContainer.children('iframe').attr('src');
                imgContainer.children('iframe').attr('src', src + '?autoplay=1');
            });
        });
    }

    $('a[href="#subscribe"]').each(function(){
        $(this).on('click', function(){
            event.preventDefault();
            $('#newsletter').fadeIn();

            $('#newsletter').find('#closer').on('click', function(){
                $('#newsletter').fadeOut();
            });
        })
    });

    $('.faq').each(function(){
        $(this).find('.opener').each(function() {
            $(this).click(function() {
                $(this).parent().parent().toggleClass('active');
                $(this).parent().siblings('.text').children('.answer').slideToggle();
            });
        });
    })

    if($('.header_textmedia').length > 0) {
        $('.header_textmedia').find('.thumbnailRemover').click(function(){
            var src = $(this).siblings('iframe').attr('src');
            $(this).siblings('iframe').attr('src', src + '&autoplay=1');
            $(this).siblings('svg').remove();
            $(this).remove();
        });
    }

    if($('.content_twoimgstopbot').length > 0) {
        $('.content_twoimgstopbot').find('a').each(function(){
            $(this).hover(function(){
                $(this).parent().parent().siblings('.imgContainer').children('img').addClass('active');
            }, function(){
                $(this).parent().parent().siblings('.imgContainer').children('img').removeClass('active');
            });
        });
    }

    if($('.testimonials__block').length > 0) {
        $('.testimonials__block').find('.imgRemover').hover(function(){
            $(this).addClass('active');
        }, function(){
            $(this).removeClass('active');
        });
        $('.testimonials__block').find('.imgRemover').click(function(){
            var src = $(this).siblings('iframe').attr('src');
            $(this).siblings('iframe').attr('src', src + '?autoplay=1');
            $(this).siblings('svg').remove();
            $(this).remove();
        });
        $('.testimonials__block').find('.thumbnailRemover').each(function(){
            $(this).hover(function(){
                $(this).parent().parent().siblings('.imgContainer').children('img').addClass('active');
            }, function(){
                $(this).parent().parent().siblings('.imgContainer').children('img').removeClass('active');
            });
            $(this).click(function(){
                event.preventDefault();
                var imgContainer = $(this).parent().parent().siblings('.imgContainer');
                imgContainer.children('img').remove();
                imgContainer.children('svg').remove();
                var src = imgContainer.children('iframe').attr('src');
                imgContainer.children('iframe').attr('src', src + '?autoplay=1');
            });
        });
    }

    if($('.content_twovidsstopbot').length > 0) {
        $('.content_twovidsstopbot').each(function(){
            $(this).find('.thumbnail').click(function(){
                var src = $(this).siblings('iframe').attr('src');
                $(this).siblings('iframe').attr('src', src + '?autoplay=1');
                $(this).remove();
            });
            $(this).find('.title').click(function(){
                var src = $(this).parent().siblings('.imgContainer').children('iframe').attr('src');
                $(this).parent().siblings('.imgContainer').children('iframe').attr('src', src + '?autoplay=1');
                $(this).parent().siblings('.imgContainer').children('.thumbnail').remove();
            });
            $(this).find('.title').hover(function(){
                $(this).parent().siblings('.imgContainer').children('.thumbnail').addClass('active');
            }, function(){
                $(this).parent().siblings('.imgContainer').children('.thumbnail').removeClass('active');
            });
        });
    }

    if($(window).width() <= 768 && $('video').length > 0){
        $('video').each(function(){
            $(this).remove();
        });
    }

    $('ul.nav_container > .menu-item-has-children').each(function(){
        $(this).on('mouseover', e => {
            $(this).addClass('open');
            $(this).children('.sub-menuWrapper').stop();
            $(this).children('.sub-menuWrapper').slideDown();
        })
        $(this).on('mouseout', e => {
            $(this).children('.sub-menuWrapper').stop();
            $(this).children('.sub-menuWrapper').slideUp();
            $('.nav_container .open').removeClass('open');
        })
    });

    if($('.header_zoom').length > 0) {
        var i = 1;
        $('.header_zoom').not('.mobile').each(function(){
            var controllerZoom = new ScrollMagic.Controller();
            $(this).attr('id', 'block' + i);
            var image = $(this).find('img');
            var bground = $(this).find('.layer');
            var text = $(this).find('.title');
            var textArea = $(this).find('.textContent');
            var animation = new TimelineMax()
                .to(bground, 0.1, {opacity: 1, ease: Linear.easeNone})
                .to(text, 0.11, {onComplete:function(){ text.addClass('visible'); }, onReverseComplete:function(){ text.removeClass('visible'); }})
                .to(image, 0.11, {onComplete:function(){ image.addClass('visible'); textArea.css('marginTop', image.height() + 15); }, onReverseComplete:function(){ image.removeClass('visible'); textArea.css('marginTop', '0'); }})
                .to(textArea, 0.15, {onComplete:function(){ textArea.addClass('visible'); }, onReverseComplete:function(){ textArea.removeClass('visible'); }});

            var scene = new ScrollMagic.Scene({
                triggerElement: 'body', 
                duration: ($(this).height() * 1.5), 
                offset: (($(window).height()/2) + ($('#header').height()))
            })
            .setPin('#block' + i)
            .setTween(animation)
            // .addIndicators({name: "zoom"}) 
            .addTo(controllerZoom);

            i++;
        });
    }
    
    $(".content_bildtext.animation").each(function(){
        var controller = new ScrollMagic.Controller();
        var curPuff = $(this);
        var offset = $(this).height() / 2;

        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 1, 
            duration: "100%", 
            offset: offset 
        })
         .on("enter", function(e) {
            $(curPuff).addClass("visible");
         })
         .on("leave", function(e) {
            $(curPuff).removeClass("visible");
         })
         // .addIndicators({name: "wroom"})
         .addTo(controller);
    });
    
    $(".content_animated_scroll .flexColumnWrapper .block").each(function(){
        var controller = new ScrollMagic.Controller();
        var curPuff = $(this);
        var offset = $(this).height() / 2;

        new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 1, 
            duration: "100%", 
            offset: offset 
        })
         .on("enter", function(e) {
            $(curPuff).addClass("visible");
         })
         .on("leave", function(e) {
            $(curPuff).removeClass("visible");
         })
         // .addIndicators({name: "wroom"})
         .addTo(controller);
    });

    if($('.archiveSection .events').length > 0) {
        $('.event.upcoming').each(function(){
            $('.upcoming.holder').append($(this));
        });
        $('.event.archive').each(function(){
            $('.archive.holder').append($(this));
        });
        var list = $('.archive.holder');
        var listItems = list.children('.event.archive');
        list.append(listItems.get().reverse());

        $('.archiveSection .filter .filtering').each(function(){
            $(this).click(function(){
                event.preventDefault();
                $('.archiveSection .filter .filtering').removeClass('active');
                $(this).addClass('active');
                if($(this).hasClass('upcoming')){
                    $('.upcoming.holder').show();
                    $('.archive.holder').hide();
                } else {
                    $('.upcoming.holder').hide();
                    $('.archive.holder').show();
                }
            });
        });
    }

    if($('.clickable').length > 0) {
        $('.clickable').each(function(){
            $(this).click(function(){
                $(this).toggleClass('open');
            });
        })
    }

    $('<span class="grow">+</span>').insertAfter('nav.nav ul li.menu-item-has-children > a');
    $(".grow").click(function (){
        $(this).parent().toggleClass('open');
        if($(this).parent().children('.sub-menu').length > 0) {
            $(this).parent().children('.sub-menu').slideToggle(500);
        } else {
            $(this).parent().children('.sub-menuWrapper').slideToggle(500);
        }
    });
    $('#header nav.nav .nav_container .menu-item').each(function(){
        if($(this).parent().hasClass('sub-menu')){
            return;
        } else {
            $(this).children('.sub-menu').first().addClass('wrapper');
            var wrapper = '<div class="sub-menuWrapper"></div>';
            $(wrapper).insertBefore($(this).children('.sub-menu'));
            $(this).children('.sub-menuWrapper').append($(this).children('.sub-menu'));
        }
    });

    var year = "";
    var cat = "";
    if($(".yearsHolder").length != 0) {
        $(".years").change(function(){
            year = ".year" + $(this).children("option:selected").val();
            if(year == '.yeardefault'){
                $('.pr' + cat).show();
                year = "";
            } else {
                $('.pr').hide();
                $('.pr' + year + cat).show();
            }
        });
    }
    if($(".catsHolder").length != 0) {
        $(".cats").change(function(){
            cat = "." + $(this).children("option:selected").val().toLowerCase();
            if(cat == '.default'){
                $('.pr' + year).show();
                cat = "";
            } else {
                $('.pr').hide();
                $('.pr' + year + cat).show();
            }
        });
    }

    if($("#addToCalendar").length != 0) {
        $("#addToCalendar").change(function(){
            var url = $(this).children("option:selected").attr("data-url");

            var win = window.open(url, '_blank');
            win.focus();

            $(this).val("default");
        });
    }
    if($(".addToCalendar").length != 0) {
        $(".addToCalendar").each(function(){
            $(this).change(function(){
                var url = $(this).children("option:selected").attr("data-url");

                var win = window.open(url, '_blank');
                win.focus();

                $(this).val("default");
            });
        });
    }

    $(document).ready(function(){
        $('nav.nav').css('opacity', 1);
    });

    // Dynamisk bakgrundsfärg till back-to-top-sektionen
    // *************************************************
    var color = $("#subpageSection").children(".page-content").children().last().css("backgroundColor");
    $(".backToTop").css("backgroundColor", color);

    if($('body').height() > (window.innerHeight * 2)) {
        $(".backToTop").css('display', 'block');
        $("#arrowUp").click(function(){
            event.preventDefault;
            $("html, body").animate({ scrollTop: 0 }, 700, "swing");
            return false;
        });
    }
    // $('body').height()


    $(".glide--carousel").ready(function() {
        $(".loader").hide();
    });

    if($(".glide").length != 0){
        var glide = new Glide('.glide', {
            type: 'carousel',
            perView: 1,
            dragThreshold: false,
            autoplay: 5000,
        });
        glide.mount();
    }

    if($(".testimonialsGlide").length != 0){
        var glide = new Glide('.testimonialsGlide', {
            type: 'carousel',
            perView: 2,
            dragThreshold: false,
            autoplay: false,
            gaps: 16,
        });
        glide.mount();
    }

    if($(".glideMobile").length != 0){
        if($(".glideMobile").length == 1){
            $(".glideMobile").each(function(){
                var glide = new Glide('.glideMobile', {
                    type: 'slider',
                    perView: 1,
                    autoplay: false,
                });
                glide.mount();
            });
        } else {
            var count = 1;
            $(".glideMobile").each(function(){
                $(this).attr("id", "mobileSlide"+count);

                var glide = new Glide("#mobileSlide"+count, {
                    type: 'slider',
                    perView: 1,
                    autoplay: false,
                });
                glide.mount();
                count++;
            });
        }
    }

    // Stänger/Öppnar videospelaren
    // ****************************
    if($('.vidCloser').length != 0){
        $('.vidCloser').click(function(){
            $(".vidBackground").fadeOut();
        });
    }
    if($('.videoOpener').length != 0){
        $('.videoOpener').click(function(){
            $(".vidBackground").fadeIn();
        });
    }

    // Tabellsortering
    // ***************
    if($('.tableSorting .tablepress').length != 0){
        $('.tableSorting').each(function() {
            var tableElement = $(this).children(".tablepress");
            var table = $(this).children(".tablepress").DataTable({
                searching: false,
                paging: false,
                info : false,
            });

            var header = table.table().columns().header();
            for(var i = 0; i <= header.length-1; i++){
                var text = $(header[i]).text();
                var id = table.column(header[i]).index();

                $(tableElement).parent().siblings(".sortWrapper").children(".customSorting").append("<option data-id='"+ id +"'>"+ text +"</option>")
            }

            $(tableElement).parent().siblings(".sortWrapper").children(".customSorting").change(function(){
                var sort = $(this).attr("data-sorting");
                var id = $(this).children("option:selected").attr("data-id");
                table.order([id, sort]).draw();
                $(this).children("option[data-id='999']").attr("disabled", "disabled");
            });
        })
    }

    if($(".content_postsExternal").length) {
        $(".page-content .content_postsExternal").last().css("paddingBottom", "20px");
    }
    if($(".content_table").length) {
        $(".page-content .content_table").last().css("paddingBottom", "60px");
    }

    var vwidth = $(window).width();
    if (vwidth < 1024) {
        $("#searchToggler").insertBefore("#mega-menu-wrap-mainNav");
        $(".content_smalltxtiframe .iframeContainer").children("iframe").attr("scrolling", "yes");
    }
    $(window).on('resize', function(){
        vwidth = $(this).width();
        if (vwidth < 1024) {
            $("#searchToggler").insertBefore("#mega-menu-wrap-mainNav");
            $(".content_smalltxtiframe .iframeContainer").children("iframe").attr("scrolling", "yes");
        } else {
            $("#searchToggler").insertAfter(".right .menu-main_navigation_right-container");
            $(".content_smalltxtiframe .iframeContainer").children("iframe").attr("scrolling", "no");
        }
    });

    $("#searchToggler").click(function(){
        $(this).toggleClass("open");
        $("#header .searchContainer").slideToggle(400);
        $(this).children('svg').toggle();
    });

    $("#formOpener").click(function(){
        $(".innerSidebar").toggleClass("open");
    });
    $("#formCloser").click(function(){
        $(".innerSidebar").removeClass("open");
    });

    // Visa dölj menyn (SlideToggle)
    //******************************
    $('#toggle_navigation').click(function() {
        $(this).toggleClass('open');
        $('.nav').slideToggle(400);
            $("body").toggleClass('noscroll');
    });

    // Lägger till Valid eller Error på inputs, textarea och select vid validering
    //****************************************************************************
    $(".row input.requiredField, .row select.requiredField, .row textarea.requiredField")
        .blur(function() {
            var $this = $(this);
            if ($this.val().trim().length !== 0) {
                $this.addClass('valid');
                $this.removeClass('error');
            } else {
                $this.addClass('error');
                $this.removeClass('valid');
            }
        });

    // Ta bort data-src när bilden är laddad.
    //***************************************
    [].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.onload = function() {
            img.removeAttribute('data-src');
        };
    });

    // Spåra Utklick (GA)
    //*******************
    function _gaLt(event){
        var el = event.srcElement || event.target;
        while (el && (typeof el.tagName == 'undefined' || el.tagName.toLowerCase() != 'a' || !el.href)) {
            el = el.parentNode;
        }
        if(el && el.href){
            var link = el.href;
            if(link.indexOf(location.host) == -1 && !link.match(/^javascript\:/i)){
                var hitBack = function(link, target){
                    target ? window.open(link, target) : window.location.href = link;
                };
                var target = (el.target && !el.target.match(/^_(self|parent|top)$/i)) ? el.target : false;
                ga( "send", "event", "Outgoing Links", link,
                    document.location.pathname + document.location.search,
                    {"hitCallback": hitBack(link, target)} );
                event.preventDefault ? event.preventDefault() : event.returnValue = !1;
            }
        }
    }
    var w = window;
    w.addEventListener ? w.addEventListener("load",function(){document.body.addEventListener("click",_gaLt,!1)},!1)
    : w.attachEvent && w.attachEvent("onload",function(){document.body.attachEvent("onclick",_gaLt)});
};
